exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DraggableEvidenceCard-module__wrapper___1kAJn{height:100%}", ""]);

// exports
exports.locals = {
	"wrapper": "DraggableEvidenceCard-module__wrapper___1kAJn"
};